module.exports = __webpack_public_path__ + "img/point_silver.457c48ee.svg";